/* ============================================================
   DND — coming-soon teaser logic (vanilla port of the DCLogic prototype)
   Drives: hero scramble, countdown + decode, scroll reveals, parallax,
   redaction un-blur, glimpse spotlight, and email "request access" capture.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-dnd-teaser]');
  if (!root) return;

  var HERO_FULL = 'DO NOT\nDISTURB';
  var CHARSET = '▒▓█/\\|<>=+*·'.split('');

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(p) { return 1 - Math.pow(1 - p, 3); }
  function pad(n) { return String(n).padStart(2, '0'); }
  function now() { return Date.now(); }

  /* drop target — dropDate (YYYY-MM-DD) injected by Liquid, 10:00 IST */
  function target() {
    var iso = root.getAttribute('data-drop-date') || '2026-08-15';
    var t = Date.parse(iso + 'T10:00:00+05:30');
    return isNaN(t) ? Date.parse('2026-08-15T10:00:00+05:30') : t;
  }

  /* ---------- hero scramble ---------- */
  var heroEl = root.querySelector('[data-hero-scramble]');
  var decodeTimer = null;
  function scrambleText(locked) {
    var out = '';
    for (var i = 0; i < HERO_FULL.length; i++) {
      var ch = HERO_FULL[i];
      if (ch === '\n' || ch === ' ') { out += ch; continue; }
      out += (i < locked) ? ch : CHARSET[(Math.random() * CHARSET.length) | 0];
    }
    return out;
  }
  function setHero(text) { if (heroEl) heroEl.textContent = text; }
  function runDecode() {
    if (!heroEl) return;
    if (decodeTimer) clearInterval(decodeTimer);
    var frame = 0;
    setHero(scrambleText(0));
    decodeTimer = setInterval(function () {
      frame++;
      var total = HERO_FULL.length;
      var locked = Math.min(total, Math.floor(frame * 0.9));
      setHero(scrambleText(locked));
      if (locked >= total) { clearInterval(decodeTimer); decodeTimer = null; setHero(HERO_FULL); }
    }, 55);
  }

  /* ---------- countdown ---------- */
  var miniEl = root.querySelector('[data-cd-mini]');
  var cdVals = [].slice.call(root.querySelectorAll('[data-cd-val]')); // 4 big digits
  var cdSection = root.querySelector('[data-cd-section]');
  var cdDecoding = false, cdLocked = 0, cdDecodeTimer = null, cdSeen = false, lastSecs = null;
  var cur = { days: '--', hours: '--', mins: '--', secs: '--' };

  function runCdDecode() {
    if (cdDecodeTimer) clearInterval(cdDecodeTimer);
    var frame = 0; cdDecoding = true; cdLocked = 0;
    cdDecodeTimer = setInterval(function () {
      frame++;
      cdLocked = Math.min(8, Math.floor(frame * 0.7));
      paintCd();
      if (cdLocked >= 8) { clearInterval(cdDecodeTimer); cdDecodeTimer = null; cdDecoding = false; paintCd(); }
    }, 60);
  }
  function paintCd() {
    var real = '' + cur.days + cur.hours + cur.mins + cur.secs;
    var shown = real;
    if (cdDecoding) {
      var d = '0123456789', out = '';
      for (var i = 0; i < real.length; i++) out += (i < cdLocked) ? real[i] : d[(Math.random() * 10) | 0];
      shown = out;
    }
    if (cdVals[0]) cdVals[0].textContent = shown.slice(0, 2);
    if (cdVals[1]) cdVals[1].textContent = shown.slice(2, 4);
    if (cdVals[2]) cdVals[2].textContent = shown.slice(4, 6);
    if (cdVals[3]) cdVals[3].textContent = shown.slice(6, 8);
    if (miniEl) miniEl.textContent = cur.days + 'd ' + cur.hours + 'h ' + cur.mins + 'm ' + cur.secs + 's';
  }
  function updCd() {
    var ms = target() - now(); if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var secs = pad(s % 60);
    cur = {
      days: pad(Math.floor(s / 86400)),
      hours: pad(Math.floor(s % 86400 / 3600)),
      mins: pad(Math.floor(s % 3600 / 60)),
      secs: secs
    };
    if (!cdDecoding) paintCd();
    if (secs === '00' && lastSecs !== '00' && lastSecs !== null) { runDecode(); runCdDecode(); }
    lastSecs = secs;
  }

  /* ---------- scroll-driven effects ---------- */
  var parallax = [].slice.call(root.querySelectorAll('[data-parallax]')).map(function (el) {
    return { el: el, speed: parseFloat(el.getAttribute('data-speed')) || 0 };
  });
  var reveals = [].slice.call(root.querySelectorAll('[data-reveal]'));
  var redacts = [].slice.call(root.querySelectorAll('[data-redact]')).map(function (el) {
    return { word: el.querySelector('[data-redact-word]'), bar: el.querySelector('[data-redact-bar]') };
  });
  var glimpse = root.querySelector('[data-glimpse]');
  var spotMask = root.querySelector('[data-spot-mask]');
  var glimpseCap = root.querySelector('[data-glimpse-cap]');

  function tick() {
    var vh = window.innerHeight;

    if (cdSection) {
      var cr = cdSection.getBoundingClientRect();
      if (!cdSeen && cr.top < vh * 0.6 && cr.bottom > 0) { cdSeen = true; runCdDecode(); }
      if (cr.bottom < 0 || cr.top > vh) cdSeen = false;
    }

    for (var i = 0; i < parallax.length; i++) {
      var p = parallax[i], r = p.el.getBoundingClientRect();
      var center = r.top + r.height / 2 - vh / 2;
      p.el.style.transform = 'translate3d(0,' + (-center * p.speed).toFixed(1) + 'px,0)';
    }

    var trig = vh * 0.9, span = vh * 0.34;
    for (var j = 0; j < reveals.length; j++) {
      var el = reveals[j], rr = el.getBoundingClientRect();
      var pv = ease(clamp((trig - rr.top) / span, 0, 1));
      el.style.opacity = pv.toFixed(3);
      el.style.transform = 'translateY(' + ((1 - pv) * 32).toFixed(1) + 'px)';
    }

    var rtrig = vh * 0.82, rspan = vh * 0.26;
    for (var k = 0; k < redacts.length; k++) {
      var rd = redacts[k]; if (!rd.word || !rd.bar) continue;
      var wr = rd.word.getBoundingClientRect();
      var rp = ease(clamp((rtrig - wr.top) / rspan, 0, 1));
      rd.word.style.filter = 'blur(' + ((1 - rp) * 6).toFixed(2) + 'px)';
      rd.word.style.opacity = (0.25 + 0.75 * rp).toFixed(3);
      rd.bar.style.transform = 'scaleX(' + (1 - rp).toFixed(3) + ')';
    }

    if (glimpse && spotMask) {
      var g = glimpse.getBoundingClientRect();
      var total = g.height - vh;
      var gp = clamp((-g.top) / total, 0, 1);
      var x = (15 + gp * 70).toFixed(1);
      var y = (30 + Math.sin(gp * Math.PI * 1.4) * 40).toFixed(1);
      var hole = (60 + gp * 30).toFixed(0);
      var soft = (180 + gp * 60).toFixed(0);
      var mask = 'radial-gradient(circle at ' + x + '% ' + y + '%, transparent 0, transparent ' + hole + 'px, black ' + soft + 'px)';
      spotMask.style.webkitMaskImage = mask;
      spotMask.style.maskImage = mask;
      if (glimpseCap) glimpseCap.style.opacity = (1 - clamp((gp - 0.55) / 0.3, 0, 1)).toFixed(3);
    }
  }

  /* ---------- email "request access" ---------- */
  var form = root.querySelector('#dnd-access-form') || root.querySelector('form');
  var emailInput = root.querySelector('[data-email]');
  var pendingBox = root.querySelector('[data-state-pending]');
  var grantedBox = root.querySelector('[data-state-granted]');
  var memberNoEl = root.querySelector('[data-member-no]');
  var joined = root.hasAttribute('data-already-joined');

  function showGranted() {
    joined = true;
    var no = String(429 + ((now() / 1000 | 0) % 900)).padStart(4, '0');
    if (memberNoEl) memberNoEl.textContent = no;
    if (pendingBox) pendingBox.style.display = 'none';
    if (grantedBox) grantedBox.style.display = '';
  }
  function doJoin() {
    if (joined) return;
    var v = emailInput && emailInput.value;
    if (!v || !/.+@.+\..+/.test(v)) {
      if (emailInput) { emailInput.style.borderBottomColor = '#b5462f'; emailInput.placeholder = 'enter a real email'; }
      return;
    }
    if (form && form.getAttribute('action')) {
      /* real Shopify customer capture — POST in the background, keep the terminal UX */
      try {
        fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .catch(function () {});
      } catch (e) {}
    }
    showGranted();
  }
  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); doJoin(); });
  }
  if (emailInput) {
    emailInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doJoin(); } });
  }
  if (joined) showGranted();

  /* ---------- boot ---------- */
  document.documentElement.classList.remove('no-js');
  runDecode();
  updCd();
  setInterval(updCd, 250);
  var running = true;
  (function loop() { if (!running) return; tick(); requestAnimationFrame(loop); })();
  tick();
})();
